/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { User } from '@/client';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

/**
 * Custom hook that returns the user's effective role based on the current context.
 * If a subtenant is selected and has a specific role, returns the subtenant role.
 * Otherwise, returns the user's tenant-level role.
 *
 * @returns The user's effective role in the current context
 */
export function useCurrentRole(): User['role'] | undefined {
  const currentUser = useMgmtPlaneStateStore((state) => state.userProfile);
  const getCurrentEffectiveRole = useMgmtPlaneStateStore((state) => state.getCurrentEffectiveRole);

  return getCurrentEffectiveRole(currentUser);
}
